import { render, staticRenderFns } from "./ListEmpresaPJ.vue?vue&type=template&id=0d27a22a"
import script from "./ListEmpresaPJ.vue?vue&type=script&lang=js"
export * from "./ListEmpresaPJ.vue?vue&type=script&lang=js"
import style0 from "./ListEmpresaPJ.vue?vue&type=style&index=0&id=0d27a22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports